export default {
  ko_KR: {
    code: 'ko_KR',
    lang: 'ko',
    displayName: 'KOR',
    noticeLang: 'KOREAN'
  }
}
